import { atom } from 'jotai'
/**
 * サイドバーの開閉状態を管理するatom
 * ページ遷移しても状態を保持する
 *
 * null は「ユーザーがまだ開閉操作をしていない」ことを表す。
 * このとき実効値は画面幅由来の既定値(`useSidebarOpen`)に委ねる。
 * 一度でも操作されたら boolean が入り、以降は画面幅より保存値を優先する。
 */
export const sidebarOpenState = atom<boolean | null>(null)
